import React from 'react';
import { useTranslation } from 'react-i18next';
import './AutoHideInput.scss';
import ToggleButton from '../../ProducerComponents/ProducerControlPanel/Widgets/ToggleButton';
import useProject from '../../../hooks/useProject';

export const AutoHideInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();

  const onChange = (value: string | number | boolean) => {
    if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
      updateStream({
        overlayAutoHideTimeout: value,
      });
    } else {
      updateEncoder(project.encoder, {
        overlayAutoHideTimeout: value,
      });
    }
  };

  return (
    <div className="auto-hide-input">
      <div className="input-title">{t('producer.inputs.auto-hide.title')}</div>
      <ToggleButton
        leftText={t('producer.common.on')}
        leftValue={true}
        leftButtonClassName={`${
          project.encoder?.overlayAutoHideTimeout ? 'control-panel-button-selected-button' : null
        }`}
        leftContentClassName="auto-hide-text"
        rightText={t('producer.common.off')}
        rightValue={false}
        rightButtonClassName={`${
          !project.encoder?.overlayAutoHideTimeout ? 'control-panel-button-selected-button' : null
        }`}
        rightContentClassName="auto-hide-text"
        footerText={t('producer.inputs.auto-hide.footer')}
        isReadOnly={false}
        onSelection={onChange}
        leftAccessibilityName={t('producer.common.on')}
        rightAccessibilityName={t('producer.common.off')}
      />
    </div>
  );
};

export default React.memo(AutoHideInput);
